import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M12 8v4m0 4h0"></path>
        <circle cx="12" cy="12" r="10" data-name="--Circle"></circle>
      </g>
    </svg>
  );
}

export default Icon;
